import React, { useContext, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { FaChevronRight } from 'react-icons/fa'

import Breadcrumbs from './form/Breadcrumbs'
import { SimpleSpinner } from '../../elem/Spinner'
import { DataContext } from './DataContext'
import { UserContext } from '../../wrappers/UserContext'
import { checkRole } from '../../../utils/user/permissions'

export default () => {
    const { formTypes } = useContext(DataContext)
    const { roles } = useContext(UserContext)

    const filteredFormTypes = useMemo(() => {
        if (!formTypes) return null
        const isFormReviewer = checkRole('Form_Reviewer', roles)
        if (isFormReviewer) return formTypes
        return formTypes.filter(ft => ft.Link !== 'merge')
    }, [formTypes, roles])

    if (!filteredFormTypes) {
        return <SimpleSpinner />
    }
    return (
        <div className="hero is-fullheight-with-navbar">
            <Breadcrumbs />
            <div className="hero-body">
                <div className="container">
                    {filteredFormTypes.map((formType, idx) => (
                        <div className="section">
                            <div className="columns is-centered is-vcentered">
                                <div className="column is-6">
                                    <article
                                        className={`message ${
                                            formType.Link === 'merge'
                                                ? `is-purple`
                                                : `is-${idx}`
                                        }`}
                                    >
                                        <div className="message-header space-between">
                                            <Link
                                                to={formType.NewFormURL}
                                                className="no-underline full-width"
                                            >
                                                <div className="headerWrapper space-between">
                                                    <span className="headerText display-flex center-vertically">
                                                        {formType.NewFormName}
                                                    </span>
                                                    <span className="iconWrapper icon is-medium">
                                                        <FaChevronRight />
                                                    </span>
                                                </div>
                                            </Link>
                                        </div>
                                        <div
                                            className="message-body"
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    formType.NewFormDescription,
                                            }}
                                        ></div>
                                    </article>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
